module.exports = __webpack_public_path__ + "img/back-arrow-icon.754cb0b6.svg";